type SingleFlightRef = {
  current: boolean;
};

type CompletePackagePrebookParams = {
  basketId: unknown;
  trackAddToCart: () => void;
  completeNavigation: (basketId: string) => void;
};

export const getValidBasketId = (basketId: unknown): string =>
  typeof basketId === 'string' ? basketId.trim() : '';

export const tryStartPackageReserve = (singleFlightRef: SingleFlightRef) => {
  if (singleFlightRef.current) return false;

  singleFlightRef.current = true;
  return true;
};

export const finishPackageReserve = (singleFlightRef: SingleFlightRef) => {
  singleFlightRef.current = false;
};

export const completePackagePrebook = ({
  basketId,
  trackAddToCart,
  completeNavigation,
}: CompletePackagePrebookParams): boolean => {
  const validBasketId = getValidBasketId(basketId);
  if (!validBasketId) return false;

  trackAddToCart();
  completeNavigation(validBasketId);
  return true;
};
